/** Formatiranje novca i procenata za veleprodaju. Cijene su bruto, valuta BAM. */

const KM = new Intl.NumberFormat("bs-BA", { style: "currency", currency: "BAM" });

/** Iznos u KM; `null`/`undefined`/NaN daju crticu da tabela nikad ne ispiše "NaN KM". */
export function fmtKm(value: number | null | undefined): string {
  if (value === null || value === undefined || !Number.isFinite(Number(value))) return "—";
  return KM.format(Number(value));
}

/** Raspon cijena varijacija: jednake granice daju jednu cijenu, različite „49,00 – 59,00 KM".
 *  Valuta se ispisuje samo jednom, na desnom kraju, da krovna kartica ne postane traka teksta. */
export function fmtKmRange(min: number | null | undefined, max: number | null | undefined): string {
  // `Number(null)` je 0, a ne NaN — prazna granica bi inače postala besplatan artikal.
  const lo = min === null || min === undefined ? Number.NaN : Number(min);
  const hi = max === null || max === undefined ? Number.NaN : Number(max);
  if (!Number.isFinite(lo)) return fmtKm(Number.isFinite(hi) ? hi : null);
  if (!Number.isFinite(hi) || Math.abs(hi - lo) < 0.005) return fmtKm(lo);
  const bare = new Intl.NumberFormat("bs-BA", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return `${bare.format(Math.min(lo, hi))} – ${fmtKm(Math.max(lo, hi))}`;
}

/** Rabat kao "20%" — bez decimala kad su nule, inače s najviše dvije. */
export function fmtPct(value: number | null | undefined): string {
  if (value === null || value === undefined || !Number.isFinite(Number(value))) return "—";
  const n = Number(value);
  const s = new Intl.NumberFormat("bs-BA", { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(n);
  return `${s}%`;
}

/** Unos broja iz `Input`-a: prazno → `null`, zarez kao decimalni separator, nevalidno → `null`. */
export function parseNumberInput(raw: string): number | null {
  const s = String(raw ?? "").trim().replace(",", ".");
  if (!s) return null;
  const n = Number(s);
  return Number.isFinite(n) ? n : null;
}

/** Unix sekunde → "dd.MM.yyyy"; `null` → crtica. */
export function fmtUnixDate(ts: number | null | undefined): string {
  if (!ts) return "—";
  const d = new Date(ts * 1000);
  const p = (n: number) => String(n).padStart(2, "0");
  return `${p(d.getDate())}.${p(d.getMonth() + 1)}.${d.getFullYear()}`;
}

/** Unix sekunde → "dd.MM.yyyy u HH:mm"; `null` → crtica. */
export function fmtUnixDateTime(ts: number | null | undefined): string {
  if (!ts) return "—";
  const d = new Date(ts * 1000);
  const p = (n: number) => String(n).padStart(2, "0");
  return `${p(d.getDate())}.${p(d.getMonth() + 1)}.${d.getFullYear()} u ${p(d.getHours())}:${p(d.getMinutes())}`;
}

/** Rok plaćanja: `confirmedAt` (unix sekunde) + rok partnera u danima; nepotvrđena narudžba nema rok. */
export function dueAtFor(confirmedAt: number | null | undefined, paymentTermDays: number): number | null {
  if (!confirmedAt) return null;
  return confirmedAt + paymentTermDays * 86400;
}
